
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site/privacy",
      function () {
        return require("private-next-pages/site/privacy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site/privacy"])
      });
    }
  